import { Card, CardHeader, CardTitle } from '@/components/ui/Card';
import type { ClientRecord } from '@/api/clients';
import { DetailList } from './DetailList';

function addressLine(c: ClientRecord) {
    if (!c.address && !c.city && !c.state && !c.zip) return '';
    const cityStateZip = [c.city, c.state].filter(Boolean).join(', ');
    const tail = [cityStateZip, c.zip].filter(Boolean).join(' ');
    return [c.address, tail].filter(Boolean).join(', ');
}

export function ClientDemographicsTab({ client: c }: { client: ClientRecord }) {
    const ec = c.emergencyContact || {};
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Card>
                <CardHeader><CardTitle>Contact</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Address', value: addressLine(c) },
                        { label: 'Phone',   value: c.phone },
                    ]}
                />
            </Card>

            <Card>
                <CardHeader><CardTitle>Emergency Contact</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Name',         value: ec.name || '' },
                        { label: 'Relationship', value: ec.rel  || '' },
                        { label: 'Phone',        value: ec.phone || '' },
                        { label: 'Email',        value: ec.email || '' },
                    ]}
                />
            </Card>

            <Card>
                <CardHeader><CardTitle>Primary Insurance</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Payer',         value: c.ins1?.payer || '' },
                        { label: 'Member ID',     value: c.ins1?.id    || '' },
                        { label: 'Group',         value: c.ins1?.group || '' },
                        { label: 'Subscriber',    value: c.ins1?.sub   || '' },
                    ]}
                />
            </Card>

            <Card>
                <CardHeader><CardTitle>Secondary Insurance</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Payer',         value: c.ins2?.payer || '' },
                        { label: 'Member ID',     value: c.ins2?.id    || '' },
                        { label: 'Group',         value: c.ins2?.group || '' },
                        { label: 'Subscriber',    value: c.ins2?.sub   || '' },
                    ]}
                />
            </Card>
        </div>
    );
}
